var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modalVideo",staticClass:"modal-video",attrs:{"tabindex":"0"}},[_c('div',{staticClass:"modal-video__media",attrs:{"id":"modal-video"}},[_c('preloader',{attrs:{"show":true,"is-color":"","lg-size":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }